import { render, staticRenderFns } from "./ProductoV.vue?vue&type=template&id=1a26c138"
import script from "./ProductoV.vue?vue&type=script&lang=js"
export * from "./ProductoV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports